import { render, staticRenderFns } from "./MessagesAndCalls.vue?vue&type=template&id=90582c00"
import script from "./MessagesAndCalls.vue?vue&type=script&lang=js"
export * from "./MessagesAndCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports